import { ref, set} from "firebase/database";
import { db} from "../../firebase";
import handleToast from "../Toast";

export const handleSaveLeadCapturedNudge = (
    nudgeData,
    customizeState,
    nudgePosition,
    user,
    nudgeName
  ) => {
  // state of first time nudge to
  // console.log("handleSaveLeadCapturedNudge customizeState", customizeState)
    let state = {
      nudgeOfferText: {
        ...nudgeData.nudgeOfferText,
        customizeProperties: {
          ...nudgeData.nudgeOfferText.customizeProperties,
          text: {
            ...nudgeData.nudgeOfferText.customizeProperties.text,
            propertyValue: customizeState.nudgeOfferText.text,
          },
          textColor: {
            ...nudgeData.nudgeOfferText.customizeProperties.textColor,
            propertyValue: customizeState.nudgeOfferText.textColor,
          },
          fontStyle: {
            ...nudgeData.nudgeOfferText.customizeProperties.fontStyle,
            propertyValue: customizeState.nudgeOfferText.fontStyle,
          },
          isExpiryTimer: {
            ...nudgeData.nudgeOfferText.customizeProperties.isExpiryTimer,
            propertyValue: customizeState.nudgeOfferText.isExpiryTimer,
          },
          minutes: {
            ...nudgeData.nudgeOfferText.customizeProperties.minutes,
            propertyValue: customizeState.nudgeOfferText.minutes,
          },
        },
      },
      nudgeCouponCode: {
        ...nudgeData.nudgeCouponCode,
        customizeProperties: {
          ...nudgeData.nudgeCouponCode.customizeProperties,
          textColor: {
            ...nudgeData.nudgeCouponCode.customizeProperties.textColor,
            propertyValue: customizeState.nudgeCouponCode.textColor,
          },
          backgroundColor: {
            ...nudgeData.nudgeCouponCode.customizeProperties.backgroundColor,
            propertyValue: customizeState.nudgeCouponCode.backgroundColor,
          },
          fontStyle: {
            ...nudgeData.nudgeCouponCode.customizeProperties.fontStyle,
            propertyValue: customizeState.nudgeCouponCode.fontStyle,
          },
          borderStyle: {
            ...nudgeData.nudgeCouponCode.customizeProperties.borderStyle,
            propertyValue: customizeState.nudgeCouponCode.borderStyle,
          },
          borderColor: {
            ...nudgeData.nudgeCouponCode.customizeProperties.borderColor,
            propertyValue: customizeState.nudgeCouponCode.borderColor,
          },
          borderWidth: {
            ...nudgeData.nudgeCouponCode.customizeProperties.borderWidth,
            propertyValue: customizeState.nudgeCouponCode.borderWidth,
          },
          borderRadius: {
            ...nudgeData.nudgeCouponCode.customizeProperties.borderRadius,
            propertyValue: customizeState.nudgeCouponCode.borderRadius,
          },
          display: {
            ...nudgeData.nudgeCouponCode.customizeProperties.display,
            propertyValue: customizeState.nudgeCouponCode.display,
          },
        },
      },
      nudgeCopyCode: {
        ...nudgeData.nudgeCopyCode,
        customizeProperties: {
          ...nudgeData.nudgeCopyCode.customizeProperties,
          text: {
            ...nudgeData.nudgeCopyCode.customizeProperties.text,
            propertyValue: customizeState.nudgeCopyCode.text,
          },
          textColor: {
            ...nudgeData.nudgeCopyCode.customizeProperties.textColor,
            propertyValue: customizeState.nudgeCopyCode.textColor,
          },
          backgroundColor: {
            ...nudgeData.nudgeCopyCode.customizeProperties.backgroundColor,
            propertyValue: customizeState.nudgeCopyCode.backgroundColor,
          },
          fontStyle: {
            ...nudgeData.nudgeCopyCode.customizeProperties.fontStyle,
            propertyValue: customizeState.nudgeCopyCode.fontStyle,
          },
          borderStyle: {
            ...nudgeData.nudgeCopyCode.customizeProperties.borderStyle,
            propertyValue: customizeState.nudgeCopyCode.borderStyle,
          },
          borderColor: {
            ...nudgeData.nudgeCopyCode.customizeProperties.borderColor,
            propertyValue: customizeState.nudgeCopyCode.borderColor,
          },
          borderWidth: {
            ...nudgeData.nudgeCopyCode.customizeProperties.borderWidth,
            propertyValue: customizeState.nudgeCopyCode.borderWidth,
          },
          borderRadius: {
            ...nudgeData.nudgeCopyCode.customizeProperties.borderRadius,
            propertyValue: customizeState.nudgeCopyCode.borderRadius,
          },
          ...(nudgeData.nudgeCopyCode.customizeProperties.href && {
            href: {
                ...nudgeData.nudgeCopyCode.customizeProperties.href,
                propertyValue: customizeState.nudgeCopyCode.href,
            }
        }),
        },
      },
      nudge: {
        ...nudgeData.nudge,
        customizeProperties: {
          ...nudgeData.nudge.customizeProperties,
          backgroundColor: {
            ...nudgeData.nudge.customizeProperties.backgroundColor,
            propertyValue: customizeState.nudge.backgroundColor,
          },
          borderColor: {
            ...nudgeData.nudge.customizeProperties.borderColor,
            propertyValue: customizeState.nudge.borderColor,
          },
          borderStyle: {
            ...nudgeData.nudge.customizeProperties.borderStyle,
            propertyValue: customizeState.nudge.borderStyle,
          },
          borderWidth: {
            ...nudgeData.nudge.customizeProperties.borderWidth,
            propertyValue: customizeState.nudge.borderWidth,
          },
          borderRadius: {
            ...nudgeData.nudge.customizeProperties.borderRadius,
            propertyValue: customizeState.nudge.borderRadius,
          },
        },
        nudgePosition: {
          ...nudgeData.nudge.nudgePosition,
          desktop: {
            ...nudgeData.nudge.nudgePosition.desktop,
            top: nudgePosition.desktop.top,
            left: nudgePosition.desktop.left,
          },
          mobile: {
            ...nudgeData.nudge.nudgePosition.mobile,
            top: nudgePosition.mobile.top,
          },
        },
      },
      nudgeShowing: {
        ...nudgeData.nudgeShowing,
        customizeProperties: {
          ...nudgeData.nudgeShowing.customizeProperties,
          allowed: {
            ...nudgeData.nudgeShowing.customizeProperties.allowed,
            propertyValue: (customizeState.nudgeShowing.allowed === undefined || customizeState.nudgeShowing.allowed.length === 0 || customizeState.nudgeShowing.allowed === "") ? [] : customizeState.nudgeShowing.allowed
          },
          prohibited: {
            ...nudgeData.nudgeShowing.customizeProperties.prohibited,
            propertyValue: customizeState.nudgeShowing.prohibited
          },
          status: {
            ...nudgeData.nudgeShowing.customizeProperties.status,
            propertyValue: customizeState.nudgeShowing.status
          }, 
          firstTimeNudgeShown: {
            ...nudgeData.nudgeShowing.customizeProperties.firstTimeNudgeShown,
            propertyValue: customizeState.nudgeShowing.firstTimeNudgeShown
          }, 
          sensitivity: {
            ...nudgeData.nudgeShowing.customizeProperties.sensitivity,
            propertyValue: customizeState.nudgeShowing.sensitivity,
          },
          device: {
            ...nudgeData.nudgeShowing.customizeProperties?.device,
            propertyValue: customizeState.nudgeShowing.device,
          },
          nudgeTimeout: {
            ...nudgeData.nudgeShowing.customizeProperties?.nudgeTimeout,
            propertyValue: customizeState.nudgeShowing.nudgeTimeout,
          },
          Geolocation: {
            ...nudgeData.nudgeShowing.customizeProperties.Geolocation,
            propertyValue: customizeState.nudgeShowing.Geolocation,
          },
          audience: {
            ...nudgeData.nudgeShowing.customizeProperties.audience,
            propertyValue: customizeState.nudgeShowing.audience,
          },
          ...(nudgeData.nudgeShowing.customizeProperties.endDate && {
            endDate: {
                ...nudgeData.nudgeShowing.customizeProperties.endDate,
                propertyValue: customizeState.nudgeShowing.endDate,
            }
        }),
          ...(nudgeData.nudgeShowing.customizeProperties.nudgeActiveDays && {
            nudgeActiveDays: {
                ...nudgeData.nudgeShowing.customizeProperties.nudgeActiveDays,
                propertyValue: customizeState.nudgeShowing.nudgeActiveDays,
            },
        }),
          ...(nudgeData.nudgeShowing.customizeProperties.priority && {
            priority: {
                ...nudgeData.nudgeShowing.customizeProperties.priority,
                propertyValue: customizeState.nudgeShowing.priority,
            }
        }),
        ...(nudgeData.nudgeShowing.customizeProperties.GeoZipcodes && {
          GeoZipcodes: {
              ...nudgeData.nudgeShowing.customizeProperties.GeoZipcodes,
              propertyValue: customizeState.nudgeShowing.GeoZipcodes,
            },
        }),
        ...(nudgeData.nudgeShowing.customizeProperties.seoKeyword && {
            seoKeyword: {
                ...nudgeData.nudgeShowing.customizeProperties.seoKeyword,
                propertyValue: customizeState.nudgeShowing.seoKeyword,
            },
        }),
        ...(nudgeData.nudgeShowing.customizeProperties.ipBasedNudgeControl && {
            ipBasedNudgeControl: {
                ...nudgeData.nudgeShowing.customizeProperties.ipBasedNudgeControl,
                propertyValue: customizeState.nudgeShowing.ipBasedNudgeControl,
            },
        }),
        ...(nudgeData.nudgeShowing.customizeProperties.firstTimeUserCheckingOptions && {
          firstTimeUserCheckingOptions: {
              ...nudgeData.nudgeShowing.customizeProperties.firstTimeUserCheckingOptions,
              propertyValue: customizeState.nudgeShowing.firstTimeUserCheckingOptions,
          },
        }),
          }
      },
      nudgeImages: {
        ...nudgeData.nudgeImages,
        customizeProperties: {
          ...nudgeData.nudgeImages.customizeProperties,
          borderColor: {
            ...nudgeData.nudgeImages.customizeProperties.borderColor,
            propertyValue: customizeState.nudgeImages.borderColor,
          },
          borderStyle: {
            ...nudgeData.nudgeImages.customizeProperties.borderStyle,
            propertyValue: customizeState.nudgeImages.borderStyle,
          },
          borderWidth: {
            ...nudgeData.nudgeImages.customizeProperties.borderWidth,
            propertyValue: customizeState.nudgeImages.borderWidth,
          },
          borderRadius: {
            ...nudgeData.nudgeImages.customizeProperties.borderRadius,
            propertyValue: customizeState.nudgeImages.borderRadius,
          },
          image: {
            ...nudgeData.nudgeImages.customizeProperties.image,
            propertyValue: customizeState.nudgeImages.image,       
          },
          display: {
            ...nudgeData.nudgeImages.customizeProperties.display,
            propertyValue: customizeState.nudgeImages.display,
          },
        }
      },
      nudgeClosed: {
        ...nudgeData.nudgeClosed,
        customizeProperties: {
          ...nudgeData.nudgeClosed.customizeProperties,
          fontSize: {
            ...nudgeData.nudgeClosed.customizeProperties.fontSize,
            propertyValue: customizeState.nudgeClosed.fontSize
          },
          textColor: {
            ...nudgeData.nudgeClosed.customizeProperties.textColor,
            propertyValue: customizeState.nudgeClosed.textColor
          }, 
          topPosition: {
            ...nudgeData.nudgeClosed.customizeProperties.topPosition,
            propertyValue: customizeState.nudgeClosed.topPosition
          }, 
          rightPosition: {
            ...nudgeData.nudgeClosed.customizeProperties.rightPosition,
            propertyValue: customizeState.nudgeClosed.rightPosition,
          }
        }
      },
      nudgeTrafficSources: {
        ...nudgeData.nudgeTrafficSources,
        customizeProperties: {
          ...nudgeData.nudgeTrafficSources.customizeProperties,
          referrerSites: {
            ...nudgeData.nudgeTrafficSources.customizeProperties.referrerSites,
            propertyValue: (customizeState.nudgeTrafficSources.referrerSites === undefined || customizeState.nudgeTrafficSources.referrerSites.length === 0 || customizeState.nudgeTrafficSources.referrerSites === "") ? [] : customizeState.nudgeTrafficSources.referrerSites
          },
          queryParams: {
            ...nudgeData?.nudgeTrafficSources?.customizeProperties?.queryParams,
            propertyValue: (customizeState?.nudgeTrafficSources?.queryParams === undefined || customizeState?.nudgeTrafficSources?.queryParams?.length === 0 || customizeState?.nudgeTrafficSources?.queryParams === "") ? [] : customizeState?.nudgeTrafficSources?.queryParams
          },
          excludeReferrerSites: {
            ...nudgeData?.nudgeTrafficSources?.customizeProperties?.excludeReferrerSites,
            propertyValue: (customizeState?.nudgeTrafficSources?.excludeReferrerSites === undefined || customizeState?.nudgeTrafficSources?.excludeReferrerSites?.length === 0 || customizeState?.nudgeTrafficSources?.excludeReferrerSites === "") ? [] : customizeState?.nudgeTrafficSources?.excludeReferrerSites
          },
          }
      },
      nudgeInputFields: {
        ...nudgeData.nudgeInputFields,
        customizeProperties: {
          ...nudgeData.nudgeInputFields.customizeProperties,
          inputField1: {
            ...nudgeData.nudgeInputFields.customizeProperties.inputField1,
            propertyValue: customizeState.nudgeInputFields.inputField1[0],
            display:customizeState.nudgeInputFields.inputField1[1],
            isRequired: customizeState.nudgeInputFields.inputField1[2],
          },
          inputField2: {
            ...nudgeData.nudgeInputFields.customizeProperties.inputField2,
            propertyValue: customizeState.nudgeInputFields.inputField2[0],
            display:customizeState.nudgeInputFields.inputField2[1],
            isRequired: customizeState.nudgeInputFields.inputField2[2],
          },
          inputField3: {
            ...nudgeData.nudgeInputFields.customizeProperties.inputField3,
            propertyValue: customizeState.nudgeInputFields.inputField3[0],
            display:customizeState.nudgeInputFields.inputField3[1],
            isRequired: customizeState.nudgeInputFields.inputField3[2],
          },
          inputField4: {
            ...nudgeData.nudgeInputFields.customizeProperties.inputField4,
            propertyValue: customizeState.nudgeInputFields.inputField4[0],
            display:customizeState.nudgeInputFields.inputField4[1],
            isRequired: customizeState.nudgeInputFields.inputField4[2],
          },
        }
      },
      nudgePosition: {
        ...nudgeData.nudgePosition,
        customizeProperties: {
          ...nudgeData.nudgePosition.customizeProperties,
          margin_left: {
            ...nudgeData.nudgePosition.customizeProperties?.margin_left,
            propertyValue: customizeState.nudgePosition.margin_left,
          },
          margin_top: {
            ...nudgeData.nudgePosition.customizeProperties?.margin_top,
            propertyValue: customizeState.nudgePosition.margin_top,
          },
          margin_right: {
            ...nudgeData.nudgePosition.customizeProperties?.margin_right,
            propertyValue: customizeState.nudgePosition.margin_right,
          },
          margin_bottom: {
            ...nudgeData.nudgePosition.customizeProperties?.margin_bottom,
            propertyValue: customizeState.nudgePosition.margin_bottom,
          },
          placement: {
            ...nudgeData.nudgePosition.customizeProperties?.placement,
            propertyValue: customizeState.nudgePosition.placement,
          },
          }
      },
      ...(customizeState.nudgeDisclaimerText && {
        nudgeDisclaimerText: {
          ...nudgeData.nudgeDisclaimerText,
          customizeProperties: {
            ...nudgeData.nudgeDisclaimerText.customizeProperties,
            text: {
              ...nudgeData.nudgeDisclaimerText.customizeProperties.text,
              propertyValue: customizeState.nudgeDisclaimerText.text,
            },
            textColor: {
              ...nudgeData.nudgeDisclaimerText.customizeProperties.textColor,
              propertyValue: customizeState.nudgeDisclaimerText.textColor,
            },
            fontStyle: {
              ...nudgeData.nudgeDisclaimerText.customizeProperties.fontStyle,
              propertyValue: customizeState.nudgeDisclaimerText.fontStyle,
            },
            fontSize: {
              ...nudgeData.nudgeDisclaimerText.customizeProperties.fontSize,
              propertyValue: customizeState.nudgeDisclaimerText.fontSize,
            },
            display: {
              ...nudgeData.nudgeDisclaimerText.customizeProperties.display,
              propertyValue: customizeState.nudgeDisclaimerText.display,
            },
          },
        },
      }),
      ...(customizeState.thankYouOfferText && {
        thankYouOfferText: {
          ...nudgeData.thankYouOfferText,
          customizeProperties: {
            ...nudgeData.thankYouOfferText.customizeProperties,
            text: {
              ...nudgeData.thankYouOfferText.customizeProperties.text,
              propertyValue: customizeState.thankYouOfferText.text,
            },
            textColor: {
              ...nudgeData.thankYouOfferText.customizeProperties.textColor,
              propertyValue: customizeState.thankYouOfferText.textColor,
            },
            fontStyle: {
              ...nudgeData.thankYouOfferText.customizeProperties.fontStyle,
              propertyValue: customizeState.thankYouOfferText.fontStyle,
            },
            isExpiryTimer: {
              ...nudgeData.thankYouOfferText.customizeProperties.isExpiryTimer,
              propertyValue: customizeState.thankYouOfferText.isExpiryTimer,
            },
            minutes: {
              ...nudgeData.thankYouOfferText.customizeProperties.minutes,
              propertyValue: customizeState.thankYouOfferText.minutes,
            },
          },
        },
      }),
      ...(customizeState.thankYouButton && {
        thankYouButton: {
          ...nudgeData.thankYouButton,
          customizeProperties: {
            ...nudgeData.thankYouButton.customizeProperties,
            text: {
              ...nudgeData.thankYouButton.customizeProperties.text,
              propertyValue: customizeState.thankYouButton.text,
            },
            textColor: {
              ...nudgeData.thankYouButton.customizeProperties.textColor,
              propertyValue: customizeState.thankYouButton.textColor,
            },
            backgroundColor: {
              ...nudgeData.thankYouButton.customizeProperties.backgroundColor,
              propertyValue: customizeState.thankYouButton.backgroundColor,
            },
            fontStyle: {
              ...nudgeData.thankYouButton.customizeProperties.fontStyle,
              propertyValue: customizeState.thankYouButton.fontStyle,
            },
            borderStyle: {
              ...nudgeData.thankYouButton.customizeProperties.borderStyle,
              propertyValue: customizeState.thankYouButton.borderStyle,
            },
            borderColor: {
              ...nudgeData.thankYouButton.customizeProperties.borderColor,
              propertyValue: customizeState.thankYouButton.borderColor,
            },
            borderWidth: {
              ...nudgeData.thankYouButton.customizeProperties.borderWidth,
              propertyValue: customizeState.thankYouButton.borderWidth,
            },
            borderRadius: {
              ...nudgeData.thankYouButton.customizeProperties.borderRadius,
              propertyValue: customizeState.thankYouButton.borderRadius,
            },
          },
        },
      }),
      ...(customizeState.formSubmissionMedia && {
        formSubmissionMedia: {
          ...nudgeData.formSubmissionMedia,
          customizeProperties: {
            ...nudgeData.formSubmissionMedia.customizeProperties,
            borderColor: {
              ...nudgeData.formSubmissionMedia.customizeProperties.borderColor,
              propertyValue: customizeState.formSubmissionMedia.borderColor,
            },
            borderStyle: {
              ...nudgeData.formSubmissionMedia.customizeProperties.borderStyle,
              propertyValue: customizeState.formSubmissionMedia.borderStyle,
            },
            borderWidth: {
              ...nudgeData.formSubmissionMedia.customizeProperties.borderWidth,
              propertyValue: customizeState.formSubmissionMedia.borderWidth,
            },
            borderRadius: {
              ...nudgeData.formSubmissionMedia.customizeProperties.borderRadius,
              propertyValue: customizeState.formSubmissionMedia.borderRadius,
            },
            media: {
              ...nudgeData.formSubmissionMedia.customizeProperties.media,
              propertyValue: customizeState.formSubmissionMedia.media,       
            },
            mediaType: {
              ...nudgeData.formSubmissionMedia.customizeProperties.mediaType,
              propertyValue: customizeState.formSubmissionMedia.mediaType, 
            },
            display: {
              ...nudgeData.formSubmissionMedia.customizeProperties.display,
              propertyValue: customizeState.formSubmissionMedia.display,
            },
            
          }
        },
      }),
      ...(customizeState.nudgeDisclaimerText && {
        nudgeDisclaimerText: {
          ...nudgeData.nudgeDisclaimerText,
          customizeProperties: {
            ...nudgeData.nudgeDisclaimerText.customizeProperties,
            text: {
              ...nudgeData.nudgeDisclaimerText.customizeProperties.text,
              propertyValue: customizeState.nudgeDisclaimerText.text,
            },
            textColor: {
              ...nudgeData.nudgeDisclaimerText.customizeProperties.textColor,
              propertyValue: customizeState.nudgeDisclaimerText.textColor,
            },
            fontStyle: {
              ...nudgeData.nudgeDisclaimerText.customizeProperties.fontStyle,
              propertyValue: customizeState.nudgeDisclaimerText.fontStyle,
            },
            fontSize: {
              ...nudgeData.nudgeDisclaimerText.customizeProperties.fontSize,
              propertyValue: customizeState.nudgeDisclaimerText.fontSize,
            },
            display: {
              ...nudgeData.nudgeDisclaimerText.customizeProperties.display,
              propertyValue: customizeState.nudgeDisclaimerText.display,
            },
          },
        },
      }),
      ...(customizeState.formSubmissionDisclaimerText && {
        formSubmissionDisclaimerText: {
          ...nudgeData.formSubmissionDisclaimerText,
          customizeProperties: {
            ...nudgeData.formSubmissionDisclaimerText.customizeProperties,
            text: {
              ...nudgeData.formSubmissionDisclaimerText.customizeProperties.text,
              propertyValue: customizeState.formSubmissionDisclaimerText.text,
            },
            textColor: {
              ...nudgeData.formSubmissionDisclaimerText.customizeProperties.textColor,
              propertyValue: customizeState.formSubmissionDisclaimerText.textColor,
            },
            fontStyle: {
              ...nudgeData.formSubmissionDisclaimerText.customizeProperties.fontStyle,
              propertyValue: customizeState.formSubmissionDisclaimerText.fontStyle,
            },
            fontSize: {
              ...nudgeData.formSubmissionDisclaimerText.customizeProperties.fontSize,
              propertyValue: customizeState.formSubmissionDisclaimerText.fontSize,
            },
            display: {
              ...nudgeData.formSubmissionDisclaimerText.customizeProperties.display,
              propertyValue: customizeState.formSubmissionDisclaimerText.display,
            },
          },
        },
      }),
      }
  
  // console.log("handleSaveLeadCapturedNudge -> state", state);
  // return;
  
    set(
      ref(db, `${user}/customise_nudge/userNudgeData/${nudgeName}`),
      state
    )
      .then(() => {
        handleToast("success", "Saved Successfully!");
      })
      .catch((err) => {
        console.log(err);
        handleToast("error", "Try after sometimes!");
      });
  };